import { Component } from "@angular/core";
import { airQuoteHistoryService } from "../airQuoteHistory/airQuoteHistory.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormControl } from "@angular/forms";
import { Constants } from "../constants/constants"
import { QuoteStatuses } from "../enums/enums";
import { ActivatedRoute } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";

@Component({
    selector: "airQuoteApproval",
    templateUrl: "/app/airQuoteApproval/airQuoteApproval.template.html",
    providers: [airQuoteHistoryService]
})

export class AirQuoteApprovalComponent {
    managerApprovals = [] as Array<IAirQuoteHistoryModel>;
    managerHistory = [] as Array<IAirQuoteHistoryModel>;
    filter = new FormControl();
    search = "";
    lastSortedColumnQuote = "id";
    lastSortedColumnHistory = "id";
    isDescQuote = true;
    isDescHistory = true;

    managerApprovalsRowCount = 0;
    managerApprovalsPageSize = 20;
    managerApprovalsPageNumber = 1;

    managerHistoryRowCount = 0;
    managerHistoryPageSize = 20;
    managerHistoryPageNumber = 1;

    restUrl = Constants.attachtmentsUrl;

    constructor(private quoteHistoryService: airQuoteHistoryService, private toast: ToastsManager, private constants: Constants, private activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        this.search = this.activatedRoute.snapshot.params["searchTerm"] ? this.activatedRoute.snapshot.params["searchTerm"] : "";

        this.filter.valueChanges.debounceTime(500).distinctUntilChanged().subscribe((term: string) => {
            if (term) {
                this.searchManagerApprovals(term, 1);
                this.searchManagerHistory(term, 1);
            } else {
                this.getManagerApprovals();
                this.getManagerApprovalHistory();
            }
        });
    }

    getManagerApprovals(): void {       
        if (this.search && this.search.length > 0) {
            this.searchManagerApprovals(this.search, this.managerApprovalsPageNumber);            
        }
        else {                   
            this.quoteHistoryService.getManagerApprovals(this.constants.user.email, this.managerApprovalsPageNumber, this.managerApprovalsPageSize).subscribe((managerApprovals: { approvals: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (managerApprovals) {                     
                    this.managerApprovals = managerApprovals.approvals;
                    this.managerApprovalsRowCount = managerApprovals.rowCount;
                }
            });
        }
    }

    getManagerApprovalHistory(): void {   
        if (this.search && this.search.length > 0)
            this.searchManagerHistory(this.search, this.managerHistoryPageNumber);
        else {            
            this.quoteHistoryService.getManagerApprovalHistory(this.constants.user.email, this.managerHistoryPageNumber, this.managerHistoryPageSize).subscribe((managerHistory: { history: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (managerHistory) {
                    this.managerHistory = managerHistory.history;
                    this.managerHistoryRowCount = managerHistory.rowCount;
                }
            });
        }
    }

    showHideDetails(quoteHistory: IAirQuoteHistoryModel): void {        
        if (quoteHistory.isVisible === undefined)
            quoteHistory.isVisible = false;       
        quoteHistory.isVisible = !quoteHistory.isVisible;
    }

    approvePurchase(quote: IAirQuoteHistoryModel): void {
        if (!quote.submitting) {            
            this.updateManagerComment(quote, true);
        }
    }

    denyPurchase(quote: IAirQuoteHistoryModel): void {
        if (!quote.submitting) {            
            this.updateManagerComment(quote, false);
        }

    }

    updateManagerComment(quote: IAirQuoteHistoryModel, approving: boolean): void {
        if (approving) {
            if (!quote.submitting) {
                quote.submitting = true;
                this.updateApprovalStatus(quote, QuoteStatuses.WaitingTrackingInformation, this.constants.user.username);
            }
        }
        else {
            if (!quote.submitting) {
                quote.submitting = true;
                this.updateApprovalStatus(quote, QuoteStatuses.Denied, this.constants.user.username);
            }
        }
    }

    updateApprovalStatus(quote: IAirQuoteHistoryModel, toFormStatusId: number, username: string): void {
        this.quoteHistoryService.updateQuoteStatus(quote.id, toFormStatusId, username).subscribe((result: boolean): void => {
            if (result) {
                var index = this.managerApprovals.indexOf(quote);

                if (index > -1)
                    this.managerApprovals.splice(index, 1);

                this.getManagerApprovalHistory();

                this.toast.success(`Quote ${quote.id} has been updated.`, "Success", { toastLife: 5000 });
            } else
                this.toast.error("Error processing you request.", "Error", { toastLife: 10000 });
        });
    }

    showApprovalArrows(column: string): boolean {
        return this.isDescQuote && this.lastSortedColumnQuote === column;
    }

    setSortOrderApproval(columnName: string) {
        if (this.lastSortedColumnQuote === columnName)
            this.isDescQuote = !this.isDescQuote;
        else
            this.isDescQuote = true;

        this.lastSortedColumnQuote = columnName;
    }

    showHistoryArrows(column: string): boolean {
        return this.isDescHistory && this.lastSortedColumnHistory === column;
    }

    setSortOrderHistory(columnName: string) {
        if (this.lastSortedColumnHistory === columnName)
            this.isDescHistory = !this.isDescHistory;
        else
            this.isDescHistory = true;

        this.lastSortedColumnHistory = columnName;
    }

    searchManagerApprovals(term: string, pageNumber: number): void {     
        if (term) {            
            this.quoteHistoryService.getManagerApprovalsSearch(this.constants.user.email, pageNumber, this.managerApprovalsPageSize, term).subscribe((managerApprovals: { approvals: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (managerApprovals) {                    
                    this.managerApprovalsPageNumber = pageNumber;
                    this.managerApprovals = managerApprovals.approvals;
                    this.managerApprovalsRowCount = managerApprovals.rowCount;
                }
            });
        }
    }

    searchManagerHistory(term: string, pageNumber: number): void {         
        if (term) {
            this.quoteHistoryService.getManagerApprovalHistorySearch(this.constants.user.email, pageNumber, this.managerHistoryPageSize, term).subscribe((managerHistory: { history: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (managerHistory) {                    
                    this.managerHistoryPageNumber = pageNumber;
                    this.managerHistory = managerHistory.history;
                    this.managerHistoryRowCount = managerHistory.rowCount;
                }
            });
        }
    }
    downloadAttachment(formTypeId:number,approvalId: number,fileName: string)
	{
		this.quoteHistoryService.downloadAttachment(formTypeId,approvalId,fileName).subscribe((blob) => {
			const link = document.createElement('a');
			const url = window.URL.createObjectURL(blob);
			link.href = url;
			link.download = fileName;
			link.click();
			window.URL.revokeObjectURL(url);
		  });
	}
}